import { Paper, Flex, SectionTitle, Grid, Text } from '@shared/components';
import { formatDate } from '@shared/utils';

import { useQSetReviewSubtask } from '../../providers';

export default function TaskInformation() {
  const { subtaskDetails } = useQSetReviewSubtask();
  const assigneeFullName = `${subtaskDetails.assignee.firstname} ${subtaskDetails.assignee.lastname}`;

  return (
    <Paper>
      <Flex
        sx={(theme) => ({ flexDirection: 'column', gap: theme.spacing(6), p: theme.spacing(6) })}
      >
        <Flex sx={(theme) => ({ gap: theme.spacing(4), flexDirection: 'column' })}>
          <SectionTitle title='Task Information' />
          <Grid
            sx={(theme) => ({
              gridTemplateColumns: `160px 1fr`,
              gap: theme.spacing(2, 6),

              '.MuiTypography-root:nth-of-type(even)': {
                wordBreak: 'break-word',
              },
            })}
          >
            <Text variant='body1'>Task Name:</Text>
            <Text variant='body1Semibold'>{subtaskDetails.name}</Text>
            <Text variant='body1'>Task Owner:</Text>
            <Text variant='body1Semibold'>{subtaskDetails.ownerName}</Text>
            <Text variant='body1'>Reviewer:</Text>
            <Text variant='body1Semibold'>{assigneeFullName}</Text>
            <Text variant='body1'>Due Date:</Text>
            <Text variant='body1Semibold'>
              {subtaskDetails.dueDate ? formatDate(subtaskDetails.dueDate) : '-'}
            </Text>
          </Grid>
        </Flex>
      </Flex>
    </Paper>
  );
}
